<!--
    Component Archiv
    @author Leander Eyer <leander.eyer@elead.ch>
-->

<template>
	<div class="container">
		<div class="content">
			<div class="bar darkText largeText">
				<div class="gridLabel bg-archiv">{{ model.getDictionary('nav_cultur')}}</div>
			</div>

			<div v-if="list.length == 0" class='work-none'>{{ model.getDictionary('cultur_nofiles') }}</div>

			<div class="document-grid" @wheel.prevent="scroll($event.deltaY > 0? 1 : -1)">
				<document-tile
					v-for="(document, index) in list.slice(slice, slice + sliceSize)"
					:key="index"
					:index="index"
					:document="document"
					:baseURL="baseURL">
				</document-tile>	

				<div
					class="document-grid-up arrow"
					v-if="slice > 0"
					@click="scroll(-1)"
					@mousedown.left="autoscroll('start', -1)"
					@mouseup.left="autoscroll('stop')"
				>&#x25B2;</div>
				<div
					class="document-grid-down arrow"
					v-if="slice < maxSlice"
					@click.left="scroll(1)"
					@mousedown.left="autoscroll('start', 1)"
					@mouseup.left="autoscroll('stop')"
				>&#x25BC;</div>

			</div>
		</div>
	</div>
</template>

<script>

	import Vue from "vue";
	import { GRID_ROWS } from "./../model/config.js";
	import { linkBaseURL } from './../model/config.js'
	import { model } from "./../model/Model.js";
	import { ListWithCursor } from "./../mixin/ListWithCursor.js";
	import { Scrollable } from "./../mixin/Scrollable.js";

	// subcomponent for document line
	const DocumentTile = Vue.component('document-tile', {
		props: ["document", "baseURL", "index"],
		template: `
			<div class='document'>
				<a :href='baseURL + document.file [0].original.link' target='_BLANK'>
				<h1>{{ document.name }}</h1>
				<p>{{ document.description }}</p>
				</a>
			</div>`
	});

	export default {

		mixins: [ ListWithCursor, Scrollable ],
		components: { DocumentTile },

		data: function() {
			return {
				// expose the model for translations
				model: model,

				// all available elements
				list: model.getDocument(),
				baseURL: linkBaseURL,

				// number of cells visible at once
				sliceSize: GRID_ROWS,
				// scroll velocity
				scrollBy: 1
			};
		},

		computed: {
			lang: function() {	return this.model.getLang();	}
		},

		watch: {
			lang: function() {
				this.list = model.getDocument();
			}
		},

		created: function() {
			// Configure the Grid
			this.sliceSize = Vue.prototype.$device == 'large'? GRID_ROWS : 4;
			this.maxSlice = Math.max(0, this.list.length - this.sliceSize);

			// adjust slice
			this.maxSlice = Math.max(0, this.list.length - this.sliceSize);
			this.slice = Math.min(this.maxSlice, this.slice);		}		
	};
</script>


<style>

	div.document {
		margin-bottom: 2rem;
	}

	div.document h1 {
		font-size: 1.4rem;
		font-weight: bold;
	}
	div.document p {
		font-size: 1.4rem;
	}

</style>